/* serviceWorker */
export const DETECT_BUILD_VERSION_SW = `${window.location.origin}/detect-build-version-sw.js`;
